import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
  MFG_EXECUTION_BOARD_QUERY_KEY,
  fetchStageQueue,
  type StageQueueFilters,
  type StageQueueResult,
} from '@/services/workOrderExecutionBoard.service';

export function useWorkOrderExecutionBoard(
  filters: StageQueueFilters,
  enabled = true
): UseQueryResult<StageQueueResult, Error> {
  return useQuery({
    queryKey: [MFG_EXECUTION_BOARD_QUERY_KEY, filters],
    queryFn: () => fetchStageQueue(filters),
    enabled,
    // TaskWOOperationUIUX.md — keep board fresh on tablet without blocking UI
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
  });
}
